import styled from "styled-components";

export const ListWrapper = styled.div`
  height: 100%;
  max-height: calc(100vh - 150px);
  overflow: auto;
`;
